export const ESTADOS_LOTES = 1;
export const ESTADOS_CIVILES = 2;
export const ESTADOS_VENTA = 3;
export const ESTADOS_COBRANZAS = 4;
